import { render, staticRenderFns } from "./devCan.vue?vue&type=template&id=376a0f72"
import script from "./devCan.vue?vue&type=script&lang=js"
export * from "./devCan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports